import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src992805003/src/alouette/node_modules/@mui/material/Container/Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src992805003/src/alouette/src/components/productLibrary/productLibraryDetail.tsx");
